import { useEffect, useState } from 'react'
import { isNil, isPresent } from 'lodash'

const useFilters = (data, setData, tab) => {
  const [filters, setFilters] = useState({
    resource: null,
    location: null,
    customer: null,
    isCompliant: null,
    isAuditSucessful: null,
    isGatheredToday: null,
    isCheckedToday: null
  })

  const handleFilters = (name, value) => {
    setFilters(state => ({...state, [name]: value || []}))
  }

  const isToday = (date) => (
    new Date().toDateString() === new Date(date).toDateString()
  )

  const filterData = () => {
    let newData = data

    if (tab === 'callbacks') {
      newData = newData.filter(i => i.isCallback)
    } else if (tab === 'new_files') {
      newData = newData.filter(i => i.isNewFile)
    } else {
      newData = newData.filter(i => !i.isCallback && !i.isNewFile)
    }

    if (isPresent(filters.resource)) {
      newData = newData.filter(i => i.resource == filters.resource.value)
    }

    if (isPresent(filters.location)) {
      newData = newData.filter(i => i.location == filters.location.value)
    }

    if (isPresent(filters.customer)) {
      newData = newData.filter(i => i.customer == filters.customer.value)
    }

    if (isPresent(filters.isCompliant)) {
      newData = newData.filter(i => i.isCompliant == filters.isCompliant.value)
    }

    if (isPresent(filters.isAuditSuccessful)) {
      newData = newData.filter(i => i.lastAudit?.successful == filters.isAuditSuccessful.value)
    }

    if (isPresent(filters.isGatheredToday)) {
      if (isNil(filters.isGatheredToday.value)) {
        newData = newData.filter(i => isNil(i.dataGatheredAt))
      } else {
        newData = newData.filter(i => isToday(i.dataGatheredAt) == filters.isGatheredToday.value)
      }
    }

    if (isPresent(filters.isCheckedToday)) {
      if (isNil(filters.isCheckedToday?.value)) {
        newData = newData.filter(i => isNil(i.complianceCheckedAt))
      } else {
        newData = newData.filter(i => isToday(i.complianceCheckedAt) == filters.isCheckedToday.value)
      }
    }

    setData(newData)
  }

  useEffect(filterData, [filters, tab])

  return [filters, handleFilters]
}

export default useFilters
